<template>
  <section>
    <div class="catalog__category-toolbar" v-if="catalogData.items.length > 0">
      <product-list-toolbar :data-source="dataSource" :search="true" position="top"></product-list-toolbar>
    </div>
    <product-active-filter-list :data-source="dataSource"></product-active-filter-list>
    <product-list
      :usp="usp"
      :data-source="dataSource">
    </product-list>
    <div class="catalog__category-toolbar">
      <product-list-toolbar :data-source="dataSource" position="bottom"></product-list-toolbar>
    </div>
  </section>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Prop} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';

  @Component({
    name: 'CatalogSearchView',
    components: {
      'product-list': ServiceContainer().getComponent('catalog-product-list'),
      'product-list-toolbar': ServiceContainer().getComponent('catalog-product-list-toolbar'),
      'product-active-filter-list': ServiceContainer().getComponent('catalog-product-active-filter-list'),
    }
  })

  export default class extends Vue {
    @Prop() readonly searchedQuery: string;
    @Prop() readonly catalogData: object;
    @Prop() readonly dataSource: string;
    @Prop() readonly usp: string;

    created() {
      this.$store.commit(`${this.dataSource}/SET_SEARCHED_QUERY`, this.searchedQuery);
      this.$store.commit(`${this.dataSource}/SET_API_RESPONSE`, this.catalogData);

      window.onpopstate = ({state}) => {
        this.$store.commit(`${this.dataSource}/SET_SEARCHED_QUERY`, null === state ? this.searchedQuery : state['searchedQuery']);
        this.$store.commit(`${this.dataSource}/SET_API_RESPONSE`, null === state ? this.catalogData : state['catalogData']);
      };
    }
  }
</script>
